import React, { useEffect, useState } from "react";
import { Download, PackageCheck } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/api/client";

const fmtSize = (n) => (n ? `${(n / 1024).toFixed(1)} KB` : "");

export default function WebsiteKits() {
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState("");

  useEffect(() => {
    api.get("/website-kits").then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, []);

  const download = async (kit) => {
    setBusy(kit.brand);
    try {
      const res = await api.get(`/website-kits/${kit.brand}/download`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${kit.brand}-website-kit.zip`;
      a.click();
      URL.revokeObjectURL(url);
    } catch { toast.error("Download failed"); }
    finally { setBusy(""); }
  };

  return (
    <div className="space-y-4 p-4 md:p-8" data-testid="website-kits-page">
      <div>
        <h1 className="font-heading text-2xl font-bold text-slate-900">Website kits</h1>
        <p className="mt-1 text-sm text-slate-500">Integration kits for brand websites: chat widget, signing proxy reference, consent slot and install checklist. No secrets are included.</p>
      </div>
      {items === null ? <p className="text-sm text-slate-400">Loading…</p> : (
        <div className="grid gap-3 md:grid-cols-3">
          {items.map((kit) => (
            <section key={kit.brand} data-testid={`website-kit-${kit.brand}`} className="rounded-xl border border-slate-200 bg-white p-4">
              <div className="flex items-center gap-2">
                <PackageCheck className={`h-5 w-5 ${kit.available ? "text-teal-700" : "text-slate-300"}`} />
                <h2 className="font-semibold text-slate-800">{kit.name}</h2>
              </div>
              {kit.available ? (
                <>
                  <p className="mt-2 break-all text-[11px] text-slate-400" data-testid={`website-kit-${kit.brand}-sha`}>SHA-256 {kit.sha256}</p>
                  <p className="text-xs text-slate-500">{fmtSize(kit.size)}</p>
                  <button type="button" data-testid={`website-kit-${kit.brand}-download`} disabled={busy === kit.brand} onClick={() => download(kit)}
                    className="mt-3 inline-flex min-h-[44px] w-full items-center justify-center gap-2 rounded-lg bg-teal-700 text-sm font-semibold text-white disabled:opacity-50">
                    <Download className="h-4 w-4" />{busy === kit.brand ? "Preparing…" : "Download kit"}
                  </button>
                </>
              ) : (
                <button type="button" disabled data-testid={`website-kit-${kit.brand}-download`}
                  className="mt-3 min-h-[44px] w-full cursor-not-allowed rounded-lg border border-slate-200 text-sm text-slate-400">Coming later</button>
              )}
            </section>
          ))}
        </div>
      )}
    </div>
  );
}
